import { ZodError, ZodSchema } from 'zod';

const NO_ERROR_REDUX_FORM = { _error: undefined };
const ERROR_REDUX_FORM = { _error: 'Invalid data form' };

const transformZodErrorToReduxFormFormat = (error: ZodError): {} => {
  return error.errors.reduce(
    (errors, error) =>
      error.path.reduce((a, b, level) => {
        if (level === error.path.length - 1) {
          a[b] = error.message;

          return errors;
        }

        if (!a[b]) {
          a[b] = {};
        }

        return a[b];
      }, errors),
    {} as { [key: string]: any },
  );
};

export const zodReduxFormValidatorResolver = (schema: ZodSchema) => (formValues: {}) => {
  const result = schema.safeParse(formValues);
  if (result.success) {
    return NO_ERROR_REDUX_FORM;
  }

  return {
    ...ERROR_REDUX_FORM,
    ...transformZodErrorToReduxFormFormat(result.error),
  };
};
